import request from '@/utils/request'
let blocs = null;
const getBlocs = async () => {
  if (blocs){
    return blocs;
  }
  blocs = await request({
    url: '/open/blocs',
    method: 'get'
  })
  return blocs;
}
const getSchool = (params) => {
  return request({
    url: '/open/schools',
    params: params,
    method: 'get'
  })
}
export {
  getBlocs, // 获取联盟列表
  getSchool
}
